module.exports = __webpack_public_path__ + "img/wink.6330db24.svg";